import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../helpers/breakpoints';

import Map from '../../static/map-icon.svg';
import Calendar from '../../static/calendar-icon.svg';
import Bed from '../../static/bed-icon.svg';

const StyledHowToBookGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  margin-top: calc(var(--v-spacing) * 2);
  grid-gap: calc(var(--gutter) * 2);
  @media screen and (min-width: ${breakpoints.md}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: var(--gutter);
  }
  @media screen and (min-width: ${breakpoints.xl}) {
    grid-gap: calc(var(--gutter) * 2);
  }
`;

const StyledHowToBookStep = styled.div`
  text-align: center;
  h4 {
    margin: 0 0 1rem;
  }
  p {
    color: var(--c-grey);
  }
  img {
    width: 100%;
    max-height: 15rem;
    margin-bottom: 2rem;
  }
`;

const HowToBookContent = props => {
  return (
    <StyledHowToBookGrid>
      <StyledHowToBookStep>
        <img src={Map} alt={'Map Icon - Created by Eris Natansa from the Noun Project'} />
        <h4>Find a Festival</h4>
        <p>Search and select the festival you're planning on going to.</p>
      </StyledHowToBookStep>
      <StyledHowToBookStep>
        <img src={Bed} alt={'Bed Icon - Created by Nikita Kozin from the Noun Project'} />
        <h4>Select a room</h4>
        <p>Browse all available, nearby property listings.</p>
      </StyledHowToBookStep>
      <StyledHowToBookStep>
        <img src={Calendar} alt={'Calendar Icon - Created by Vichanon Chaimsuk from the Noun Project'} />
        <h4>Book and enjoy</h4>
        <p>Book one of our hand-picked destinations.</p>
      </StyledHowToBookStep>
    </StyledHowToBookGrid>
  );
};

export default HowToBookContent;
